<template>
  <!--<li><router-link to="/" class="header-link">Home</router-link></li>-->
  <section id="GeneralContactFormWrap">
    <div class="ContentAligher SectionSpacing">
        <div class="row">
          <div class="col-md-11 col-md-offset-1 col-sm-offset-0">
            <h1 class="bold white">{{ title }}</h1>
            <p>{{ description }}</p>

            <div class="contactForm" ref="FormScroll">
             <form name="generalForm" id="generalForm"  @submit.prevent="processForm" >
                    <div class="row">
                        <div class="col-sm-12">
                          <div id="Gform-result"></div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-sm-6">
                          <div class="field">
                            <span v-show="errors.has('full_name')" class="help is-danger">{{ errors.first('full_name') }}</span>
                            <input type="text" name="full_name" id="full_name_g" placeholder=" " v-model="full_name" v-validate="'required'" >
                            <label for="full_name_g">Full Name *</label>
                          </div>
                        </div>

                        <div class="col-sm-6">
                          <div class="field">
                            <span v-show="errors.has('phone')" class="help is-danger">{{ errors.first('phone') }}</span>
                            <input type="tel" name="phone" id="phone_g" placeholder=" " v-model="phone" v-validate="'required|numeric'" >
                            <label for="phone_g">Phone *</label>
                          </div>
                        </div>


                        <div class="col-sm-6">
                          <div class="field">
                            <span v-show="errors.has('email')" class="help is-danger">{{ errors.first('email') }}</span>
                            <input type="email" name="email" id="email_g" placeholder=" " v-model="email" v-validate="'required|email'" >
                            <label for="email_g">Email *</label>
                          </div>
                        </div>

                        <div class="col-sm-6">
                          <div class="field">
                            <span v-show="errors.has('company')" class="help is-danger">{{ errors.first('company') }}</span>
                            <input type="text" name="company" id="company_g" placeholder=" " v-model="company" v-validate="'required'" >
                            <label for="company_g">Company *</label>
                          </div>
                        </div>

                        

                        <div class="col-sm-12">
                          <div class="field">
                            <textarea name="message" id="message_g" placeholder=" " rows="4" v-model="message"></textarea>
                            <label for="message_g">How can we help you?</label>
                          </div>
                        </div>

                        <div class="col-sm-12">
                           <div class="padd-tb15">
                            <vue-recaptcha sitekey="6LeCifkUAAAAAKgCVQnMF52ZoNQZYevMlpb7HEsE" :loadRecaptchaScript="true"></vue-recaptcha>
                           </div>
                        </div>



                        <div class="col-sm-6">
                          <div class="padd-tb15">
                            <button class="" id="SubmitContact">Submit</button>
                          </div>
                        </div>

                      </div>
                  </form>
                </div>

          </div>
        </div>
    </div>
  </section>
</template>
<script>

import * as $ from 'jquery'
import 'paroller.js';

import Vue from 'vue';
import VeeValidate from 'vee-validate';

import VueRecaptcha from 'vue-recaptcha';

Vue.use(VeeValidate);

export default{
  name: 'GeneralForm',
  components: { VueRecaptcha },
  data: function() {
    return {
      title: 'Have a project for us',
      description:'Need support? In our commitment to excellence and safety, we remain ready to support to you from the start of your project, right up to its  completion. ',
     //banner:require('./../../static/images/banner/contact.jpg'),
      full_name: '',
      email: '',
      phone: '',
      company: '',
      message: ''
    }
  },
  mounted() {
    
  },
    methods: {
      scrollMeTo(refName) {
        var element = this.$refs[refName];
        var top = element.offsetTop;
        window.scrollTo(0, top);
      },
      processForm: function() {
        //console.log({ name: this.name, email: this.email });
        //alert('Processing!');

          this.$validator.validateAll().then((result) => {
          if (result) {
              //alert("success");
        
                //replace submit button with loader
                $( "#SubmitContact" ).fadeOut('fast', function(){
                    $( '<img src="'+ require('../assets/images/loader.gif') +'" id="loader_gif" />' ).insertAfter(this);
                });

                // Send the data using post
                var form = $( "#generalForm" );  
                var posting = $.post('https://elevinteriors.com/ajax/contact.php', form.serialize() );

                // Put the results in a div
                posting.done(function( data ) {
                  var obj = $.parseJSON(data);
                  $( "#Gform-result" ).empty().append( obj.msg );
                  this.scrollMeTo("FormScroll");

                  if(obj.success == 'true')
                  {
                    //success
                    form.find("input[type=text], input[type=email], input[type=tel], input[type=number], textarea").val("");//reset
                  }
                  $( "#SubmitContact" ).fadeIn('fast', function(){
                    $( '#loader_gif' ).remove();
                  });
                });

          }
          });      
      }

  }
}
</script>



// WEBPACK FOOTER //
// src/components/GeneralForm.vue